module.exports = __webpack_public_path__ + "img/slider-5.fe84ac8d.jpg";